"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PbxVtecOmnicanal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="236457" id="pbx-vtec-omnicanal" className="bg-gradient-to-br from-[hsl(217,91%,20%)] to-primary py-10 md:py-14 px-8 text-foreground">
      <div ref={ref} className={`max-w-7xl mx-auto flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="font-default text-6xl md:text-7xl font-bold tracking-widest text-white mb-6 max-w-4xl">Central Telefónica PBX-Vtec y Chat <span className="text-chart-4">Omnicanal</span></h1>
        
        <p className="font-sans text-xl text-white/90 max-w-2xl mb-10">Maneje su call center de voz y unifique WhatsApp, Facebook Messenger, Instagram, Webchat y más en una plataforma poderosa y fácil de usar.</p>
        
        <Button size="lg" asChild className="rounded-md px-8 bg-chart-4 text-[hsl(217,91%,20%)] hover:scale-105 transition-transform duration-300 font-default font-bold shadow-lg">
          <Link to="/OmnichannelPage">Ver Solución</Link>
        </Button>
      </div>
    </section>;
}